import React, { useState } from "react";
import "../../Style/ServiceGallerySection.css";
import { myCustomTheme } from "../../Theme";

import img1 from "../../Assets/Services-Image-1.jpg";
import img2 from "../../Assets/Services-Image-2.jpg";
import img3 from "../../Assets/Services-Image-3.jpg";

export default function ServiceGallerySection() {
  const [selected, setSelected] = useState(null);
  const [closing, setClosing] = useState(false);

  const theme = myCustomTheme;

  const closeModal = () => {
    setClosing(true);

    setTimeout(() => {
      setSelected(null);
      setClosing(false);
    }, 250); // match CSS animation time
  };

  return (
    <div
      className="service-section"
      style={{
        background: theme.colors.bg_primary,
      }}
    >
      <div className="image-row">

        <img
          src={img1}
          alt="service 1"
          className="img-left"
          onClick={() => setSelected(img1)}
          style={{ boxShadow: theme.shadows.soft }}
        />

        <img
          src={img2}
          alt="service 2"
          className="img-center"
          onClick={() => setSelected(img2)}
          style={{ boxShadow: theme.shadows.soft }}
        />

        <img
          src={img3}
          alt="service 3"
          className="img-right"
          onClick={() => setSelected(img3)}
          style={{ boxShadow: theme.shadows.soft }}
        />

      </div>

      {/* MODAL */}
      {selected && (
        <div className="modal-overlay" onClick={closeModal}>
          <div
            className={`modal-box ${closing ? "closing" : ""}`}
            onClick={(e) => e.stopPropagation()}
          >
            <img src={selected} alt="preview" className="modal-image" />
          </div>
        </div>
      )}
    </div>
  );
}